import {environment} from "../../../environments/environment";
import {FuncionesExterno} from "../../externo/funciones-Externo";
import {catchError} from "rxjs/operators";
import {of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Component} from "@angular/core";
import {PeticionesComponent} from "../peticiones.component";
import {AlertArgumentarioComponent} from "../../VistasGenericas/alert-argumentario/alert-argumentario.component";
import {MatDialog} from "@angular/material/dialog";
export class Gestiones {

    public static createGestion(http: HttpClient, parametros: any) {

        const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };
        return new Promise<any>((resolve, reject) =>
        {
            http.post<any[]>(environment.logisticaWSBase + "/gestiones/insertGestion", parametros,  { headers } )
                .subscribe
                ({
                    next(res)
                    {
                        resolve(res);
                    },
                    error(err)
                    {
                        console.error(err);
                        reject(err);
                    },
                })
        });
    }

    /*public static getPdfAlbaran(http: HttpClient, orderId: number, dialog:MatDialog) {

        const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };
        return new Promise<any>((resolve, reject) =>
        {
            http.post<any[]>(environment.logisticaWSBase + "/gestiones/getAlbaranPdf", orderId,  { headers, responseType: 'blob' as 'json' } )
                .subscribe
                ({

                    next(res)
                    {
                      console.log(res);
                        Gestiones.downloadFile(res)
                    },
                    error(err)
                    {
                      console.log(err);
                        AlertArgumentarioComponent.mostrarArgumentario("Alerta!", [err.error], false, true, true, dialog);
                        reject(err);
                    },
                })
        });
    }*/

    public static getPdfAlbaran(http: HttpClient, orderId: number, dialog: MatDialog) {
      const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

      return new Promise<any>((resolve, reject) => {
        http.post<any[]>(
          environment.logisticaWSBase + "/gestiones/getAlbaranPdf",
          orderId,
          { headers, responseType: 'blob' as 'json' }
        ).subscribe({
          next(res) {
            Gestiones.downloadFile(res);
            resolve(res);
          },
          error(err) {
            if (err.error instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                const mensaje = reader.result as string;
                AlertArgumentarioComponent.mostrarArgumentario(
                  "Alerta!",
                  [mensaje],
                  false, true, true,
                  dialog
                );
              };
              reader.onerror = () => {
                AlertArgumentarioComponent.mostrarArgumentario(
                  "Alerta!",
                  ["Error desconocido al leer el mensaje del servidor."],
                  false, true, true,
                  dialog
                );
              };
              reader.readAsText(err.error);
            } else {
              AlertArgumentarioComponent.mostrarArgumentario(
                "Alerta!",
                [JSON.stringify(err.error)],
                false, true, true,
                dialog
              );
            }

            reject(err);
          }
        });
      });
    }


  public static downloadFile(data: any) {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url= window.URL.createObjectURL(blob);
        window.open(url);
    }

    public static createDevolucion(http: HttpClient, parametros: any) {

        // Se añade bearer token al header
        const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

        return new Promise<any>((resolve, reject) =>
        {
            http.post<any[]>(environment.logisticaWSBase + "/gestiones/crearDevolucion", parametros,  { headers } )
                .subscribe
                ({
                    next(res)
                    {
                        resolve(res);
                    },
                    error(err)
                    {
                        console.error(err);
                        reject(err);
                    },
                })
        });

    }

    public static createReclamacion(http: HttpClient, parametros: any) {

        // Se añade bearer token al header
        const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

        return new Promise<any>((resolve, reject) =>
        {
            http.post<any[]>(environment.logisticaWSBase + "/gestiones/crearReclamacion", parametros,  { headers } )
                .subscribe
                ({
                    next(res)
                    {
                        resolve(res);
                    },
                    error(err)
                    {
                        console.error(err);
                        reject(err);
                    },
                })
        });

    }

    public static getComentarios(http: HttpClient, parametros: any) {

        // Se añade bearer token al header
        const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

        return new Promise<any>((resolve, reject) =>
        {
            http.post<any[]>(environment.logisticaWSBase + "/gestiones/getComentarios", parametros,  { headers } )
                .subscribe
                ({
                    next(res)
                    {
                        resolve(res);
                    },
                    error(err)
                    {
                        console.error(err);
                        reject(err);
                    },
                })
        });

    }

    public static insertComentario(http: HttpClient, comentario: any) {

        // Se añade bearer token al header
        const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

        return new Promise<any>((resolve, reject) =>
        {
            http.post<any[]>(environment.logisticaWSBase + "/gestiones/insertComentario", comentario,  { headers } )
                .subscribe
                ({
                    next(res)
                    {
                        resolve(res);
                    },
                    error(err)
                    {
                        console.error(err);
                        reject(err);
                    },
                })
        });

    }

}
